/*
  bfroz-forms.js : formulaires natifs Shopify des pages Partenaire, Ambassadeur et Contact.
  - toast : port minimal de sonner (bas-droite, 356 px, 13 px, 4 s, glissement 400 ms) avec les classes
    du site (fond --background, texte --foreground, bordure --border, shadow-lg) et les icônes de sonner.
    API : window.BFROZ.toast.success(msg) / .error(msg).
  - [data-bfroz-form][data-validate="ambassador"] : mêmes contrôles que handleSubmit de la source
    (prénom, nom, courriel + 4 consentements) → toast d'erreur au texte de la source ; bouton « ... » pendant l'envoi.
  - au chargement : [data-form-success][data-toast] → toast succès (toast.success de la source après envoi) ;
    [data-form-error][data-toast] → toast erreur.
  - select[data-select-placeholder] : attribut data-placeholder tant qu'aucune valeur (couleur du placeholder,
    comme data-[placeholder] du SelectTrigger Radix).
*/
(function () {
  'use strict';

  var BFROZ = (window.BFROZ = window.BFROZ || {});
  if (BFROZ.formsReady) return;
  BFROZ.formsReady = true;

  var DURATION = 4000;
  var EXIT = 400;
  var ICONS = {
    success: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20" aria-hidden="true" focusable="false"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/></svg>',
    error: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20" aria-hidden="true" focusable="false"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/></svg>'
  };
  var CSS = [
    '.bfroz-toaster{position:fixed;right:32px;bottom:32px;z-index:999999999;display:flex;flex-direction:column;gap:14px;width:356px;margin:0;padding:0;list-style:none;outline:none;box-sizing:border-box;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"}',
    '.bfroz-toast{display:flex;align-items:center;gap:6px;box-sizing:border-box;width:100%;padding:16px;border-radius:8px;font-size:13px;line-height:1.5;font-weight:500;overflow-wrap:anywhere;background:hsl(var(--background));color:hsl(var(--foreground));border:1px solid hsl(var(--border));box-shadow:0 10px 15px -3px rgb(0 0 0 / .1),0 4px 6px -4px rgb(0 0 0 / .1);opacity:0;transform:translateY(100%);transition:transform .4s,opacity .4s}',
    '.bfroz-toast.is-visible{opacity:1;transform:translateY(0)}',
    '.bfroz-toast__icon{display:flex;align-items:center;justify-content:flex-start;flex-shrink:0;position:relative;width:16px;height:16px;margin-left:-3px;margin-right:4px}',
    '.bfroz-toast__icon svg{width:20px;height:20px;flex-shrink:0}',
    '@media (max-width:600px){.bfroz-toaster{right:16px;left:16px;bottom:16px;width:auto}}',
    '@media (prefers-reduced-motion:reduce){.bfroz-toast{transition:none}}'
  ].join('');

  var list = null;
  function ensureToaster() {
    if (list) return list;
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);
    list = document.createElement('ol');
    list.className = 'bfroz-toaster';
    list.setAttribute('aria-live', 'polite');
    document.body.appendChild(list);
    return list;
  }

  function showToast(type, message) {
    if (!message) return;
    var host = ensureToaster();
    var item = document.createElement('li');
    item.className = 'bfroz-toast';
    item.setAttribute('role', 'status');
    item.setAttribute('data-type', type);
    var icon = document.createElement('div');
    icon.className = 'bfroz-toast__icon';
    icon.innerHTML = ICONS[type] || '';
    var title = document.createElement('div');
    title.className = 'bfroz-toast__title';
    title.textContent = message;
    item.appendChild(icon);
    item.appendChild(title);
    host.appendChild(item);

    var done = false;
    function dismiss() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      item.classList.remove('is-visible');
      setTimeout(function () {
        if (item.parentNode) item.parentNode.removeChild(item);
      }, EXIT);
    }
    var timer = setTimeout(dismiss, DURATION);
    item.addEventListener('click', dismiss);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        item.classList.add('is-visible');
      });
    });
    return dismiss;
  }

  BFROZ.toast = {
    success: function (message) { return showToast('success', message); },
    error: function (message) { return showToast('error', message); },
    show: showToast
  };

  // ---------- selects : couleur du placeholder ----------
  function syncSelect(select) {
    if (select.value === '') select.setAttribute('data-placeholder', '');
    else select.removeAttribute('data-placeholder');
  }

  // ---------- validation de l'ambassadeur (même condition que handleSubmit de la source) ----------
  function ambassadorValid(form) {
    var fields = form.querySelectorAll('[data-required-field]');
    for (var i = 0; i < fields.length; i++) {
      if (!String(fields[i].value || '').trim()) return false;
    }
    var consents = form.querySelectorAll('[data-consent-required]');
    for (var j = 0; j < consents.length; j++) {
      if (!consents[j].checked) return false;
    }
    return true;
  }

  function bindForm(form) {
    var submit = form.querySelector('[data-submit]');
    // Phase de capture : sur la cible, les écouteurs « capture » passent AVANT les écouteurs classiques,
    // quel que soit l'ordre d'inscription. La protection anti-pourriel de Shopify (hCaptcha/reCAPTCHA)
    // pose son propre écouteur « submit » sur le formulaire et, une fois le défi résolu, appelle
    // form.submit() natif (sans événement) : si on ne l'arrête pas ici, une candidature sans
    // consentements partirait quand même. stopImmediatePropagation() l'empêche de démarrer.
    form.addEventListener('submit', function (event) {
      if (form.getAttribute('data-validate') === 'ambassador' && !ambassadorValid(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        BFROZ.toast.error(form.getAttribute('data-toast-required'));
        return;
      }
      if (submit) {
        submit.setAttribute('aria-busy', 'true');
        setTimeout(function () {
          submit.disabled = true;
          submit.textContent = '...';
        }, 0);
        // Si la page est toujours là après 8 s (défi anti-pourriel fermé sans réponse, réseau coupé),
        // on rend le bouton : sinon il resterait « ... » et désactivé sans issue.
        setTimeout(restore, 8000);
      }
    }, true);
    function restore() {
      if (!submit || !submit.disabled) return;
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
      submit.textContent = submit.getAttribute('data-label') || submit.textContent;
    }
    if (submit) window.addEventListener('pageshow', restore);
  }

  function init() {
    var forms = document.querySelectorAll('[data-bfroz-form]');
    for (var i = 0; i < forms.length; i++) bindForm(forms[i]);

    var selects = document.querySelectorAll('select[data-select-placeholder]');
    for (var j = 0; j < selects.length; j++) {
      syncSelect(selects[j]);
      selects[j].addEventListener('change', function () { syncSelect(this); });
    }

    var success = document.querySelector('[data-form-success][data-toast]');
    if (success) BFROZ.toast.success(success.getAttribute('data-toast'));
    var error = document.querySelector('[data-form-error][data-toast]');
    if (error) BFROZ.toast.error(error.getAttribute('data-toast'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
